export function parallax() {
    let $window = $(window);
    let $sectionParallax = $(".parallax-section");

    function parallaxEffect(elements, itemTop, winTop, itemHeight) {
        if (winTop + $window.innerHeight() > itemTop && winTop + $window.innerHeight() < itemTop + itemHeight + $window.innerHeight() ) {
            elements.each(function (i, it) {
                let speed = $(it).data("scroll-speed");
                let offset = (winTop - itemTop) / speed;

                if ($(it).hasClass("move-up")){
                    if ($(it).closest(".hero-section")) {
                        if (offset < 50) {
                            $(it).css({"margin-top":offset+"px"});
                        }
                    } else {
                        $(it).css({"transform":"translateY("+offset+"px)"});
                    }
                }
                if ($(it).hasClass("shadow")){
                    offset = (itemTop - (winTop + $window.innerHeight())) * speed;
                    // offset*=-1;

                    if (offset <= 5 && offset >= -5) {
                        if (i % 2 === 0) {
                            offset*=-1;
                        }

                        if ($(it).closest(".jobs-list-box").length) {
                            offset*=-1;
                        }

                        $(it).css({"transform":"rotate("+offset+"deg)"});
                    }
                }

                if ($(it).hasClass("zoom")){
                    offset = 1 + (((winTop + $window.innerHeight() / 4) - itemTop) * speed);
                    if (offset >= 1 && offset < 1.5) {
                        $(it).css({"transform":"scale("+offset+")"});
                    }
                }

                if ($(it).hasClass("move-left")){
                    if (($(it).closest(".comparison-holder").length && offset < 0) || ($(it).closest(".comparison-holder").length && $window.width() < 1024)) {
                        offset = 0;
                    } 

                    $(it).css({"transform":"translateX("+offset+"px)"});
                }
                if ($(it).hasClass("move-right")){
                    offset*=-1;

                    if (($(it).closest(".comparison-holder").length && offset > 0) || ($(it).closest(".comparison-holder").length && $window.width() < 1024)) {
                        offset = 0;
                    }

                    $(it).css({"transform":"translateX("+offset+"px)"});
                }
            });
        }
    }

    $window.on("load scroll", function () {
        $sectionParallax.each(function(i, it){
            let parallaxElements = $(it).find(".parallax");
            let itemTop = $(it).offset().top;
            let winTop = $window.scrollTop();
            parallaxEffect(parallaxElements, itemTop, winTop, $(it).height());
        });
    });
}








// WEBPACK FOOTER //
// ./assets/js/modules/parallax.js